import { sendDataLayer } from "common/utils/ga";
import {
  track as trackRudderstack,
  trackRudderstackImageProcessingCompleted
} from "common/utils/rudderstack/tracker";

export { trackRudderstack, trackRudderstackImageProcessingCompleted, sendDataLayer };

// DATA-2874: dispatch through RudderStack with sendToMixpanel so design_lab_*
// events land in both the warehouse and Mixpanel. Mixpanel-only delivery since
// June 2025 left the warehouse design_lab_* tables dark. When Mixpanel is
// decommissioned, flip the third argument to false.
export const track = (event: string, properties: Record<string, unknown> = {}) => {
  trackRudderstack(event, properties, true);
};

// The RudderStack SDK persists its queue across navigation only once it has
// received the event. When Mixpanel enrichment is pending, the event sits in
// an in-page queue that navigation would destroy — so navigation-adjacent
// call sites get a short grace window before resolving, mirroring the old
// Mixpanel callback/1s-timeout behavior.
//
// Deliberately shorter than MIXPANEL_ENRICHMENT_WAIT_MS (3000ms): navigation
// must not be held for the full enrichment wait. Events still queued when the
// user navigates are delivered by the pagehide drain in
// track-rudderstack-event.js. Do not unify these two values.
const NAVIGATION_GRACE_MS = 500;

export const trackAsync = (event: string, properties: Record<string, unknown>) =>
  new Promise<void>(resolve => {
    try {
      track(event, properties);
    } catch {
      // tracking must never block the caller
    } finally {
      setTimeout(resolve, NAVIGATION_GRACE_MS);
    }
  });
